<div
  class="uploader-class"
  [ngClass]="{
    'hide-uploader-button':
      !permissionObj['Intake_Submission_AttachDocument_Visible'],
    'hide-uploader':
      !permissionObj['Intake_Submission_DocumentDragAndDrop_Visible']
  }"
  *ngIf="isDocSectionEditable"
>
  <dds-uploader
    id="intake-uploader"
    *ngIf="shouldShowUploader"
    [heading]="uploadAreaOptions.heading"
    [description]="uploadAreaOptions.description"
    [dragAndDropText]="uploadAreaOptions.dragAndDropText"
    [isDragAndDrop]="uploadAreaOptions.isDragAndDrop"
    [isMultiple]="uploadAreaOptions.isMultiple"
    [acceptFormats]="uploadAreaOptions.acceptFormats"
    [acceptExtensions]="uploadAreaOptions.acceptExtensions"
    [restrictedFormats]="uploadAreaOptions.restrictedFormats"
    [restrictedExtensions]="uploadAreaOptions.restrictedExtensions"
    [exceptSymbols]="uploadAreaOptions.exceptSymbols"
    [btnLabel]="uploadAreaBtnLabel"
    [isInverse]="uploadAreaOptions.isInverse"
    [disabled]="!permissionObj['Intake_Submission_DocumentDragAndDrop_Enable']"
    [chooseFileBtnKind]="uploadAreaOptions.chooseFileBtnKind"
    (uploadedItems)="openUploadModel($event)"
  ></dds-uploader>

  <dds-button
    *ngIf="isAddLinkButtonVisible"
    class="button-style"
    [theme]="options.theme"
    [kind]="options.kind"
    [size]="options.size"
    [width]="options.width"
    [disabled]="!permissionObj['Intake_Submission_AddDocumentLink_Enable']"
    (click)="openDocumentLinkModel()"
    >Add link</dds-button
  >
</div>

<div [ngClass]="{ hidden: !showDocumentTable }">
  <app-document-table
    *ngIf="permissionObj['Intake_Submission_DocumentTable_Visible']"
    [tableId]="tableId"
    [submissionId]="submissionId"
    [submissionTypeId]="submissionTypeId"
    [submissionStatusId]="submissionStatusId"
    [progressiveStatus]="progressiveStatus"
    [submissionTypeCode]="submissionTypeCode"
    [permissionObj]="permissionObj"
    [showArchiveIt]="showArchiveColumn"
    [showToggleBtn]="showToggleBtn"
    [toggleOpen]="toggleOpen"
    [filterDocArr]="filterDocArr"
    [isEditable]="isDocSectionEditable"
    [submissionStatus]="submissionStatus"
    [opportunityDocs]="opportunityDocs"
    [submissionTypeSubId]="submissionTypeSubId"
    [rmReviewedGuidanceNoteHeader]="rmReviewedGuidanceNoteHeader"
    [rmReviewedGuidanceNoteBody]="rmReviewedGuidanceNoteBody"
    [optOutOfSelfReview]="optOutOfSelfReview"
    [currentStatusChangeDate]="currentStatusChangeDate"
    [otherSubmissionSubType]="otherSubmissionSubType"
    [documentTypeOptions]="documentTypeOptions"
    [documentStatusOptions]="documentStatusOptions"
    (documentTableData)="documentTableDataValue($event)"
  ></app-document-table>
</div>
